import { cloneElement, Children, ReactElement } from 'react';
import { useFilterText } from './hooks';
import { ChildrenWithInputText, SelectValueType } from './types';
import { RawSelect, RawSelectProps } from './RawSelect';

export type BasicSelectProps<TValue extends SelectValueType = string> = RawSelectProps<TValue>;

const addInputPropsToChild = (
  filterText: string,
  cb: (searchQuery: string) => void,
  children: ChildrenWithInputText | ChildrenWithInputText[],
): ReactElement[] =>
  Children.map<ReactElement, ReactElement>(children, (child) =>
    cloneElement(child, {
      ...child.props,
      onChange: cb,
      value: filterText,
    }),
  );

export function BasicSelect<TValue extends SelectValueType = string>({
  onSearchChange,
  children,
  ...props
}: BasicSelectProps<TValue>) {
  const [filterText, setFilterText] = useFilterText('');
  const onChangeCb = (searchQuery: string) => {
    onSearchChange?.(searchQuery);
    setFilterText(searchQuery);
  };

  return (
    <RawSelect filterText={filterText} {...props}>
      {children && addInputPropsToChild(filterText, onChangeCb, children)}
    </RawSelect>
  );
}
